import { useContext as r } from "react";
import { I18nContext as s } from "../context/KnockI18nProvider.mjs";
import { locales as e } from "../languages/index.mjs";
function m() {
  const {
    translations: o,
    locale: n
  } = r(s);
  return {
    locale: n,
    t: (t) => o[t] || e.en.translations[t]
  };
}
export {
  m as useTranslations
};
//# sourceMappingURL=useTranslations.mjs.map
